// LIBRARIES //
import React from 'react';
import { connect } from 'react-redux';
import { Summary } from '@yuhuinc/ui-library';
import styled from 'styled-components';
import Auth from 'j-toker';

// COMPONENTS //
import CardHeader from '../CardComponent/CardHeader';
import CardBody from '../CardComponent/CardBody';

// HELPERS //
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import { AccentColor } from 'helpers/AccentColorHelper';

// ACTIONS //
import { getTenant } from 'actions/landlordTenantsActions';
import { showOptOutResident, showPasswordReset, showDeleteDrawer } from '../store/actions';

const Spacer = styled.div`
  margin-top: 40px;
  display: block;
`;

const NotificationPreferenceHeader = styled.p`
  line-height: 24px;
  font-size: 18px;
`;

const NotificationPreference = styled.p`
  line-height: 20px;
  font-size: 16px;
`;

const NotificationDiv = styled.div`
  margin-bottom: 18px;
`;

const notificationVerbiage = preferences => {
  let verbiage = getTranslatedString('landlordPortal.tenantOverview.none');

  if (!!preferences && preferences.email && preferences.sms) {
    verbiage = getTranslatedString('landlordPortal.tenantOverview.emailSms');
  } else if (!!preferences && preferences.email) {
    verbiage = getTranslatedString('landlordPortal.tenantOverview.emailOnly');
  } else if (!!preferences && preferences.sms) {
    verbiage = getTranslatedString('landlordPortal.tenantOverview.smsOnly');
  }

  return verbiage;
};

const AccountDetails = ({
  residentData,
  showOptOutResident,
  showPasswordReset,
  showDeleteDrawer,
}) => {
  const notificationData = residentData.notification_preferences;

  return (
    <div>
      <CardHeader>
        {getTranslatedString('residentDrawer.residentDetailTab.accountDetails.title')}
      </CardHeader>
      <CardBody>
        <Summary
          title={getTranslatedString(
            'residentDrawer.residentDetailTab.accountDetails.notificationPreferences.title'
          )}
          divider
        >
          <NotificationDiv>
            <NotificationPreferenceHeader>
              {getTranslatedString(
                'residentDrawer.residentDetailTab.accountDetails.notificationPreferences.buildingCommunications'
              )}
            </NotificationPreferenceHeader>
            <NotificationPreference>
              {notificationVerbiage(notificationData.building_communications)}
            </NotificationPreference>
          </NotificationDiv>
          <NotificationDiv>
            <NotificationPreferenceHeader>
              {getTranslatedString(
                'residentDrawer.residentDetailTab.accountDetails.notificationPreferences.payments'
              )}
            </NotificationPreferenceHeader>
            <NotificationPreference>TODO</NotificationPreference>
          </NotificationDiv>
          <NotificationDiv>
            <NotificationPreferenceHeader>
              {getTranslatedString(
                'residentDrawer.residentDetailTab.accountDetails.notificationPreferences.maintenanceRequests'
              )}
            </NotificationPreferenceHeader>
            <NotificationPreference>
              {notificationVerbiage(notificationData.requests)}
            </NotificationPreference>
          </NotificationDiv>
          <NotificationDiv>
            <NotificationPreferenceHeader>
              {getTranslatedString(
                'residentDrawer.residentDetailTab.accountDetails.notificationPreferences.amenityBookings'
              )}
            </NotificationPreferenceHeader>
            <NotificationPreference>
              {notificationVerbiage(notificationData.events)}
            </NotificationPreference>
          </NotificationDiv>
          <NotificationDiv>
            <NotificationPreferenceHeader>
              {getTranslatedString(
                'residentDrawer.residentDetailTab.accountDetails.notificationPreferences.promotions'
              )}
            </NotificationPreferenceHeader>
            <NotificationPreference>
              {notificationVerbiage(notificationData.promotions)}
            </NotificationPreference>
          </NotificationDiv>
        </Summary>
        <Spacer />
        <Summary
          title={getTranslatedString(
            `residentDrawer.residentDetailTab.accountDetails.${residentData.opted_out
              ? 'optIn'
              : 'optOut'}.title`
          )}
          divider
          buttonText={getTranslatedString(
            `residentDrawer.residentDetailTab.accountDetails.${residentData.opted_out
              ? 'optIn'
              : 'optOut'}.button`
          )}
          buttonColor={AccentColor()}
          buttonOnClick={showOptOutResident}
        >
          {getTranslatedString(
            `residentDrawer.residentDetailTab.accountDetails.${residentData.opted_out
              ? 'optIn'
              : 'optOut'}.body`
          )}
        </Summary>
        <Spacer />
        <Summary
          title={getTranslatedString(
            'residentDrawer.residentDetailTab.accountDetails.passwordReset.title'
          )}
          divider
          buttonText={getTranslatedString(
            'residentDrawer.residentDetailTab.accountDetails.passwordReset.button'
          )}
          buttonColor={AccentColor()}
          buttonOnClick={() => {
            Auth.requestPasswordReset({
              email: residentData.email,
              config: undefined,
              landlord_id: residentData.landlord_id,
              language_code: getCurrentLocale(),
            });
            showPasswordReset();
          }}
        >
          {getTranslatedString(
            'residentDrawer.residentDetailTab.accountDetails.passwordReset.body'
          )}
        </Summary>
        <Spacer />
        <Summary
          title={getTranslatedString(
            'residentDrawer.residentDetailTab.accountDetails.deleteResident.title'
          )}
          divider
          buttonText={getTranslatedString(
            'residentDrawer.residentDetailTab.accountDetails.deleteResident.button'
          )}
          buttonColor={AccentColor()}
          buttonOnClick={showDeleteDrawer}
        >
          {getTranslatedString(
            'residentDrawer.residentDetailTab.accountDetails.deleteResident.body'
          )}
        </Summary>
      </CardBody>
    </div>
  );
};

export default connect(null, {
  getTenant,
  showOptOutResident,
  showPasswordReset,
  showDeleteDrawer,
})(AccountDetails);
